import {TSMap} from "typescript-map";
import Platform from "platform/Platform";
import {StorageKey} from "enum/StorageKey";
import Utils from "platform/util/Utils";
import {TradeColumn} from "enum/TradeColumn";
import {SortDirection} from "platform/enum/SortDirection";
import {SymbolTableState} from "core/redux/symbols/SymbolReduxState";

enum SymbolCategory {

    MyWatchlist = "symbolsMyWatchlist",
    FX = "FX",
    Stock = "Stock",
    Commodity = "Commodity",
    Crypto = "Crypto",
    Index = "Index",
    NotSet = "NotSet",
}

namespace SymbolCategory {

    export function serialize(key: StorageKey, tables: TSMap<string, SymbolTableState>): void {
        Platform.storage().setItem(key, JSON.stringify(tables));
    }

    export async function deserialize(key: StorageKey): Promise<TSMap<string, SymbolTableState>> {
        const tables: TSMap<string, SymbolTableState> = new TSMap();
        const symbolsSortJson: string = await Platform.storage().getItem(key);
        if (!Utils.isObjectEmpty(symbolsSortJson)) {
            try {
                const symbolsSort: object = JSON.parse(symbolsSortJson);
                Object.keys(symbolsSort).forEach((category: string) => {
                    const table: any = symbolsSort[category];
                    const tableSort: SymbolTableState = {
                        activeColumn: table.activeColumn,
                        sort: new TSMap<TradeColumn, SortDirection>()
                    };
                    Object.keys(table.sort).forEach((column: TradeColumn) => {
                        tableSort.sort.set(column, table.sort[column]);
                    });
                    tables.set(category, tableSort);
                });
                return tables;
            } catch (e) {
            }
        } else {
            tables.set(SymbolCategory.MyWatchlist, defaultTableState());
        }
        return Promise.resolve(tables);
    }

    export function defaultTableState(): SymbolTableState {
        return {
            activeColumn: TradeColumn.Symbol,
            sort: new TSMap<TradeColumn, SortDirection>([
                [TradeColumn.Symbol, SortDirection.Ask]
            ])
        };
    }

    export function order(category: string): number {
        if (category) {
            switch (category) {
                case SymbolCategory.MyWatchlist:
                    return 0;
                case SymbolCategory.Stock:
                    return 1;
                case SymbolCategory.Index:
                    return 2;
                case SymbolCategory.Commodity:
                    return 3;
                case SymbolCategory.FX:
                    return 4;
                case SymbolCategory.Crypto:
                    return 5;
                case SymbolCategory.NotSet:
                    return 6;
            }
        }
        return 0;
    }
}

export {SymbolCategory};
